import {
  Avatar,
  AvatarRole,
  AvatarSize,
  DropdownMenu,
  Icon,
  IconName,
} from '@usealloy/component-library';
import { useContext, useMemo } from 'react';

import { UserContext } from '~/dashboard/context';

import { Sidebar } from '../component/Sidebar';
import { BetaFeaturesMenu } from './BetaFeaturesMenu';
import { StyledFlyoutTriggerButton } from './FlyoutTriggerCaret';

interface AgentProfileMenuProps {
  expanded?: boolean;
}

/**
 * The SideNav Menu Item that holds the current agent's profile
 */
export const AgentProfileMenuItem = ({ expanded }: AgentProfileMenuProps) => {
  const { agent } = useContext(UserContext);

  const agentName = [agent?.firstName, agent?.lastName]
    .filter(Boolean)
    .join(' ');

  const agentRole = useMemo(() => {
    if (agent?.isEmployee) {
      return AvatarRole.Alloy;
    }
    if (agent?.adminAgentCustomerRole === 'Admin') {
      return AvatarRole.Admin;
    }
    if (agent?.isAgent) {
      return AvatarRole.User;
    }
    return AvatarRole.Default;
  }, [agent]);

  return (
    <Sidebar.MenuItem style={{ padding: '4px 16px 16px 16px' }}>
      <DropdownMenu
        modal={false}
        trigger={(
          <StyledFlyoutTriggerButton tooltip="Profile Menu" tooltipSide="top">
            <Avatar
              name={agentName}
              role={agentRole}
              size={AvatarSize.Medium}
              hideLabel
            />
            {expanded && (
              <span className="fs-unmask" style={{ flex: 1, minWidth: 0 }}>
                {agentName}
              </span>
            )}
            {expanded && (
              <Icon
                icon={IconName.CaretRight}
                style={{ flexShrink: 0, marginLeft: 'auto' }}
              />
            )}
          </StyledFlyoutTriggerButton>
        )}
      >
        <DropdownMenu.Content
          side="right"
          style={{
            justifyContent: 'center',
            maxWidth: 400,
          }}
        >
          <BetaFeaturesMenu />
          <DropdownMenu.Item
            onSelect={() => {
              window.location.href = `${window.location.origin}/logout`;
            }}
          >
            <Icon icon={IconName.Power} size="small" />
            <span>Logout</span>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu>
    </Sidebar.MenuItem>
  );
};
